import React, { Component } from 'react';
import { string, object } from 'prop-types';
import { inject, observer } from 'mobx-react';

import UpgradeModalLayout from '../upgrade-modal-layout';

class UpgradeModal extends Component {
  static propTypes = {
    appConfig: object.isRequired,
    biLogger: object.isRequired,
    view: object.isRequired,
    integrationType: string.isRequired,
    integrationName: string.isRequired,
  };

  biData = {
    integrationType: this.props.integrationType,
    modalType: 'upgrade',
  };

  componentDidMount() {
    this.props.biLogger.integrationModalView(this.biData);
    document.addEventListener('visibilitychange', this.checkPremium);
  }

  componentWillUnmount() {
    document.removeEventListener('visibilitychange', this.checkPremium);
  }

  checkPremium = () => {
    const { appConfig, view } = this.props;

    if (document.visibilityState === 'visible') {
      view.setLoading(true);
      appConfig
        .fetchPremium()
        .then((isPremium) =>
          isPremium ? view.closeModal() : view.setLoading(false),
        );
    }
  };

  handleClose = () => {
    const { biLogger, view } = this.props;
    biLogger.integrationModalClosed(this.biData);
    biLogger.integrationModalCloseViaCloseBar(this.biData);
    view.closeModal();
  };

  handlePrimaryButtonClick = () => {
    const {
      biLogger,
      integrationType,
      appConfig: { metaSiteId },
    } = this.props;

    biLogger.integrationModalCtaClick({ ...this.biData, ctaType: 'upgrade' });

    const url = 'https://www.wix.com/store/plans';
    window.open(
      `${url}?siteGuid=${metaSiteId}&referralAdditionalInfo=marketing_integrations_${integrationType}`,
      '_blank',
    );
  };

  render() {
    return (
      <UpgradeModalLayout
        integrationName={this.props.integrationName}
        onPrimaryButtonClick={this.handlePrimaryButtonClick}
        onClose={this.handleClose}
        isLoading={this.props.view.isModalLoading || false}
      />
    );
  }
}

export default inject('view', 'appConfig', 'biLogger')(observer(UpgradeModal));
